export const manifest = {
  screens: {
    scr_rh022r: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_hyeqw0: { name: "Meet Milangela", route: "/meet-milangela", position: {"x":1560,"y":220} },
    scr_dcyalu: { name: "Start Your Journey", route: "/start-your-journey", position: {"x":2960,"y":220} },
    scr_6jwskt: { name: "Meditation Between Worlds", route: "/start-your-journey/meditation-between-worlds", position: {"x":160,"y":2200} },
    scr_f0rb7z: { name: "Sound-Infused Renewal", route: "/start-your-journey/sound-infused-renewal", position: {"x":1560,"y":2200} },
    scr_u35dkn: { name: "Sopotje", route: "/start-your-journey/sopotje", position: {"x":2960,"y":2200} },
    scr_jtubsq: { name: "Journal", route: "/journal", position: {"x":160,"y":4180} },
    scr_1pxcot: { name: "Guided Meditations", route: "/guided-meditations", position: {"x":1560,"y":4180} },
    scr_jon31s: { name: "Podcasts", route: "/podcasts", position: {"x":2960,"y":4180} },
    scr_qtohtk: { name: "Creative Corner", route: "/creative-corner", position: {"x":4360,"y":4180} },
    scr_ff8a9r: { name: "Let’s Connect", route: "/lets-connect", position: {"x":5760,"y":4180} },
    scr_d09n6x: { name: "Testimonials", route: "/testimonials", position: {"x":7160,"y":4180} },
  },
  sections: {
    sec_2ztxsy: { name: "Onboarding Flow", x: 0, y: 0, width: 4320, height: 1180 },
    sec_u8l6hh: { name: "Journey Programs", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_c2yafh: { name: "Content & Community", x: 0, y: 3960, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_2ztxsy", children: [
      { kind: "screen", id: "scr_rh022r" },
      { kind: "screen", id: "scr_hyeqw0" },
      { kind: "screen", id: "scr_dcyalu" },
    ] },
    { kind: "section", id: "sec_u8l6hh", children: [
      { kind: "screen", id: "scr_6jwskt" },
      { kind: "screen", id: "scr_f0rb7z" },
      { kind: "screen", id: "scr_u35dkn" },
    ] },
    { kind: "section", id: "sec_c2yafh", children: [
      { kind: "screen", id: "scr_jtubsq" },
      { kind: "screen", id: "scr_1pxcot" },
      { kind: "screen", id: "scr_jon31s" },
      { kind: "screen", id: "scr_qtohtk" },
      { kind: "screen", id: "scr_ff8a9r" },
      { kind: "screen", id: "scr_d09n6x" },
    ] },
  ],
}
